import React from 'react';
import { PropTypes } from 'prop-types';
import { Pie } from 'react-chartjs-2';

const OBSPIE = (props) => {
    const {
        annualResults, selectedFinancing, doughnutSlider, projectState, sgipToggle,
    } = props;

    const doughYears = doughnutSlider;

    const annualUtilityPayment =
        annualResults[doughYears].formattedAnnualBill -
            annualResults[doughYears].annualSolarSavings >
        0
            ? annualResults[doughYears].formattedAnnualBill -
              annualResults[doughYears].annualSolarSavings
            : 0;

    const obsVsUtilityCostPolar = {
        datasets: [
            {
                data: [
                    annualUtilityPayment.toFixed(0).replace(/(\d)(?=(\d{3})+\.)/g, '$1,'),
                    annualResults[doughYears].annualSolarSavings
                        .toFixed(0)
                        .replace(/(\d)(?=(\d{3})+\.)/g, '$1,'),
                    annualResults[doughYears].annualOBSPayment,
                    annualResults[doughYears].obsITC,
                ],
                backgroundColor: ['#db4141', '#61ff9a', '#f243d8', '#dfff61'],
            },
        ],
        labels: ['Remaining Utility ($)', 'Solar Value ($)', 'OBS ($) ', 'ITC ($)'],
    };

    const obsVsUtilityCostPolarRECS = {
        datasets: [
            {
                data: [
                    annualUtilityPayment.toFixed(0).replace(/(\d)(?=(\d{3})+\.)/g, '$1,'),
                    annualResults[doughYears].annualOBSPayment
                        .toFixed(0)
                        .replace(/(\d)(?=(\d{3})+\.)/g, '$1,'),
                    annualResults[doughYears].annualSolarSavings
                        .toFixed(0)
                        .replace(/(\d)(?=(\d{3})+\.)/g, '$1,'),
                    annualResults[doughYears].obsITC,
                    annualResults[doughYears].recs.toFixed(0).replace(/(\d)(?=(\d{3})+\.)/g, '$1,'),
                ],
                backgroundColor: ['#db4141', '#f243d8', '#61ff9a', '#dfff61', '#FFAC33'],
            },
        ],
        labels: [
            'Remaining Utility ($)',
            'OBS ($) ',
            'Solar Value ($)',
            'ITC ($)',
            'RECs ($)',
        ],
    };

    const obsVsUtilityCostPolarSGIP = {
        datasets: [
            {
                data: [
                    annualUtilityPayment.toFixed(0).replace(/(\d)(?=(\d{3})+\.)/g, '$1,'),
                    annualResults[doughYears].annualOBSPayment
                        .toFixed(0)
                        .replace(/(\d)(?=(\d{3})+\.)/g, '$1,'),
                    annualResults[doughYears].annualOBSSavings
                        .toFixed(0)
                        .replace(/(\d)(?=(\d{3})+\.)/g, '$1,'),
                    annualResults[doughYears].obsITC,
                    annualResults[doughYears].sgip,
                    annualResults[doughYears].sgipPBI,
                ],
                backgroundColor: ['#db4141', '#f243d8', '#61ff9a', '#dfff61', '#FFAC33', '#42f4c8', '#8641f4'],
            },
        ],
        labels: [
            'Remaining Utility ($)',
            'OBS ($) ',
            'Solar Value ($)',
            'ITC ($)',
            'SGIP ($)',
            'SGIP PBI',
        ],
    };

    const obsVsUtilityCostPolarSMART = {
        datasets: [
            {
                data: [
                    annualUtilityPayment.toFixed(0).replace(/(\d)(?=(\d{3})+\.)/g, '$1,'),
                    annualResults[doughYears].annualOBSPayment
                        .toFixed(0)
                        .replace(/(\d)(?=(\d{3})+\.)/g, '$1,'),
                    annualResults[doughYears].annualOBSSavings
                        .toFixed(0)
                        .replace(/(\d)(?=(\d{3})+\.)/g, '$1,'),
                    annualResults[doughYears].obsITC,
                    annualResults[doughYears].smart,
                ],
                backgroundColor: ['#db4141', '#f243d8', '#61ff9a', '#dfff61', '#42f4c8'],
            },
        ],
        labels: [
            'Remaining Utility ($)',
            'OBS ($) ',
            'Solar Value ($)',
            'ITC ($)',
            'SMART ($)',
        ],
    };

    const obsVsUtilityCostPolarNYCommercial = {
        datasets: [
            {
                data: [
                    annualUtilityPayment.toFixed(0).replace(/(\d)(?=(\d{3})+\.)/g, '$1,'),
                    annualResults[doughYears].annualOBSPayment
                        .toFixed(0)
                        .replace(/(\d)(?=(\d{3})+\.)/g, '$1,'),
                    annualResults[doughYears].annualOBSSavings
                        .toFixed(0)
                        .replace(/(\d)(?=(\d{3})+\.)/g, '$1,'),
                    annualResults[doughYears].obsITC,
                    annualResults[doughYears].nyserdaRebate,
                    annualResults[doughYears].cashNYAbatement,
                ],
                backgroundColor: ['#db4141', '#f243d8', '#61ff9a', '#dfff61', '#42f4c8', '#8334eb', '#eb34cc'],
            },
        ],
        labels: [
            'Remaining Utility ($)',
            'OBS ($) ',
            'Solar Value ($)',
            'ITC ($)',
            'NYSERDA Rebate',
            'Property Abatement',
        ],
    };

    let data = null;
    if (projectState === 3 && selectedFinancing === 3) {
        data = obsVsUtilityCostPolarRECS;
    } else if (projectState === 1 && selectedFinancing === 3 && sgipToggle === true) {
        data = obsVsUtilityCostPolarSGIP;
    } else if (projectState === 2 && selectedFinancing === 3) {
        data = obsVsUtilityCostPolarSMART;
    } else if (projectState === 4 && selectedFinancing === 3) {
        data = obsVsUtilityCostPolarNYCommercial;
    } else {
        data = obsVsUtilityCostPolar;
    }

    return (
        <div>
            {selectedFinancing === 3 ? (
                <li>
                    <Pie
                        height={345}
                        data={data}
                        options={{ maintainAspectRatio: true }}
                    />
                </li>
            ) : null}
        </div>
    );
};

OBSPIE.propTypes = {
    annualResults: PropTypes.object.isRequired,
    selectedFinancing: PropTypes.number.isRequired,
    doughnutSlider: PropTypes.number.isRequired,
    projectState: PropTypes.number.isRequired,
    sgipToggle: PropTypes.bool.isRequired,
};

export default OBSPIE;



// WEBPACK FOOTER //
// ./src/containers/Simulator/TabBar/Results/Graphs/OBSPIE/OBSPIE.js